import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const actionButton = css`
  padding-left: 0;
  padding-right: 0;
`

export const addNewAccountButton = css`
  margin-top: ${size[8]};
  margin-bottom: ${size[24]};
`
